/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_New_TitleInputs */

const vi_pl_pnk_new_title = /** @type {(inputs: Pl_Pnk_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo PNK lô chè mua`)
};

/**

* @param {Pl_Pnk_New_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_new_title = /** @type {((inputs?: Pl_Pnk_New_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_New_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_new_title(inputs)
});